import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { Button, Input } from 'components/Ui';
import { selectIsProcessing } from 'containers/PrimoProfile/selectors';
import { showDrawer as showDrawerAction } from 'containers/DrawerManager/actions';
import ClearIcon from '@material-ui/icons/Clear';
import EmailIcon from '@material-ui/icons/Email';
import styles from './styles.scss';

const InvoiceEmailBlock = ({ data, onEmailChange, isProcessing }) => {
  const [showConfirmation, changeShowConfirmation] = useState(false);

  const [emailValue, setEmailValue] = useState(data);

  const handleChange = (event) => {
    setEmailValue(event.target.value);
  };

  const handleRemove = () => {};

  const handleShowConfirmation = () => changeShowConfirmation(true);

  const handleCancel = () => {
    setEmailValue(data);
    changeShowConfirmation(false);
  };

  const handleSaveEmail = () => {
    onEmailChange(emailValue);
    changeShowConfirmation(false);
  };

  const renderEmailValue = () => (
    <Fragment>
      <div className={styles.emailContainer}>
        <div className={styles.emailIconContainer}>
          <span className={styles.emailIcon}>
            <EmailIcon />
          </span>
        </div>
        <div>
          <div>
            <span>{emailValue}</span>
          </div>
          <div>
            <Button
              link
              text="Edit"
              onClick={handleShowConfirmation}
              type="button"
            />
          </div>
        </div>
      </div>
    </Fragment>
  );

  const renderEmailInput = () => (
    <Fragment>
      <div className={styles.emailInput}>
        <Input
          value={emailValue}
          name="email"
          onChange={handleChange}
          ariaLabel="Email address"
        />
      </div>
    </Fragment>
  );

  return (
    <div
      className={classnames(
        styles.paymentMethodBlock,
        showConfirmation && styles.focus,
      )}
    >
      <div className={styles.info}>
        {showConfirmation
          ? renderEmailInput(emailValue)
          : renderEmailValue(emailValue)}
      </div>
      <div className={styles.buttons}>
        {showConfirmation ? (
          <Fragment>
            <Button
              link
              text="Save"
              onClick={handleSaveEmail}
              type="button"
              data-tracking="Save email eInvoice perferences"
              loading={isProcessing}
            />
            <Button link text="Cancel" onClick={handleCancel} type="button" />
          </Fragment>
        ) : (
          <Fragment>
            <Button
              className={styles.clearIcon}
              link
              icon={<ClearIcon />}
              onClick={handleRemove}
              type="button"
            />
          </Fragment>
        )}
      </div>
    </div>
  );
};

InvoiceEmailBlock.propTypes = {
  data: PropTypes.object,
  isProcessing: PropTypes.bool,
  onEmailChange: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  isProcessing: selectIsProcessing(),
});

const mapDispatchToProps = {
  showDrawer: showDrawerAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceEmailBlock);
